import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class VendureAuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if this request is to Vendure API
    if (request.url.includes(environment.vendureAPI)) {
      const modifiedRequest = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
        },
        // CRITICAL: This ensures cookies are sent with cross-origin requests
        withCredentials: true
      });

      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}
